import * as React from 'react'
import { useEffect } from 'react'
import { Provider } from 'react-redux'
import store from '../../../store'
import { loadDictionaries, loadElements } from '../../../actions/elements_order'
import TemplatePreview from './template_preview'
import Form from './form'
import FilterTabs from './filter_tabs'
import { initUploader } from '../../../actions/uploader_actions'

type ElementsOrderAppProps = {
  elements: any
  locationId: number
  dictionaries: {
    elementGroups: any[]
    elementSubGroups: any[]
    departments: any[]
    locationGroups: any[]
    locationSubGroups: any[]
    locationDepartments: any[]
  }
  accessControl: {
    canSendOrder: boolean
    canApproveOrder: boolean
    canEditOrder: boolean
    canCancelOrder: boolean
  }
  form: {
    submitData: {
      url: string
      method: string
    }
    submitMethod: string
    tableHeaderTitle: string
    authenticityToken: string
    deliveryDate: string
    comment: string
    availableCountries: string[]
    deliveryAttention: string
    deliveryPhoneNumber: string
    deliveryInfo: string
    locationAddress: any
    orderAddress: any
  }
  companySettings: {
    allowProjectCreation: boolean
    allowImageUpload: boolean
    requiredFields?: string[]
  }
  uploaderOptions: any
  requireInstallation: boolean
  installationStartDate: string
  installationEndDate: string
}

export default function ElementOrderApp(props: ElementsOrderAppProps) {
  const {
    elements,
    locationId,
    dictionaries,
    companySettings,
    uploaderOptions,
    requireInstallation,
    installationStartDate,
    installationEndDate,
  } = props

  useEffect(() => {
    store.dispatch(loadDictionaries(dictionaries, companySettings, uploaderOptions))
    store.dispatch(loadElements(elements))
  }, [])

  const { accessControl, form } = props
  return (
    <Provider store={store}>
      <div>
        {accessControl.canEditOrder && <FilterTabs locationId={locationId} accessControl={accessControl} />}
        {accessControl.canEditOrder && <TemplatePreview />}
        <Form
          submitData={form.submitData}
          tableHeaderTitle={form.tableHeaderTitle}
          accessControl={accessControl}
          authenticityToken={form.authenticityToken}
          deliveryAttention={form.deliveryAttention}
          deliveryDate={form.deliveryDate}
          deliveryPhoneNumber={form.deliveryPhoneNumber}
          deliveryInfo={form.deliveryInfo}
          comment={form.comment}
          locationAddress={form.locationAddress}
          orderAddress={form.orderAddress}
          availableCountries={form.availableCountries}
          requireInstallation={requireInstallation}
          installationStartDate={installationStartDate}
          installationEndDate={installationEndDate}
          companySettings={companySettings}
        />
      </div>
    </Provider>
  )
}
